import React from 'react'
import { Box, Button, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import './herosection.css'

const HeroSection = () => {
  return (
    <div className="my-style" id='hero-section'>
      <Box sx={{ flexGrow: 1, border: 0 }}>
        <Container>
          <Grid container spacing={2} >
            <Grid xs={12} sm={7} md={7} lg={7} className="left-hero"  data-aos="fade-right" data-aos-duration="1000">
              <Typography variant="h6" className="sub-heading">
                Hi, my name is
              </Typography>
              <Typography variant="h4" className="name-heading">
                Ahsan Iqbal<span>.</span>
              </Typography>
              <Typography variant="h4" className="dev-heading">
                Full Stack Web Developer
              </Typography>
              <Typography variant="subtitle1" className="bio-heading">
                I am Self-motivated Web Developer. Passionate about building
                user-friendly Dynamic , responsive web applications to increase
                customer sales. Equipped with knowledge in JavaScript , Reactjs,
                Nextjs, Firebase, MERN Stack and other programming languages
              </Typography>
              <a href="mailto:ahsan.chy.iqbal.com?subject=Hi!%20I%20want%20To%20Hire%20you" target="_blank" rel="noreferrer">
                <Button className="hire-now-btn">
                      Hire Me
                  </Button>
              </a>
            </Grid>
            <Grid xs={12} sm={5} md={5} lg={5} className="img-box" data-aos="fade-left" data-aos-duration="1000">
              <img className="logo-image"
                src="https://cdn-icons-png.flaticon.com/512/1129/1129196.png"
                alt="bio-img"
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default HeroSection